// English strings for the flow dashboard (Stage 3). One table so an Urdu one
// can be dropped in later.
export const FD = {
  nav: 'Kitchen Flow',
  navDescription: 'Everything between an order and the supplier, live',
  title: 'Kitchen flow',
  subtitle: 'Where things are stuck right now. Tap a box to see what is behind the number.',
  asOf: (d: string) => `Business day ${d}`,
  updated: (t: string) => `Updated ${t}`,
  nodes: {
    catering_orders: 'Catering orders',
    plans: 'Plans',
    production: 'Cooking',
    requisitions: 'Store requests',
    store: 'Store',
    purchasing: 'Buying',
  } as Record<string, string>,
  hints: {
    catering_orders: 'Orders booked for events',
    plans: 'What the kitchen will cook',
    production: 'Batches being made',
    requisitions: 'Kitchen ↔ store',
    store: 'Stock to send, stock running low',
    purchasing: 'Orders with suppliers',
  } as Record<string, string>,
  flags: {
    waiting: 'waiting',
    short: 'short',
    in_transit: 'on the way',
    overdue: 'late',
  } as Record<string, string>,
  flagsByNode: {
    catering_orders: { waiting: 'not sent to the kitchen', overdue: 'event passed, not delivered', short: 'delivered, not paid' },
    plans: { in_transit: 'in progress' },
    production: { in_transit: 'cooking', short: 'made less' },
    store: { short: 'below par' },
    purchasing: { short: 'part-delivered' },
  } as Record<string, Record<string, string>>,
  comingSoon: 'Coming soon',
  allClear: 'All clear',
  open: 'Open',
  openScreen: 'Go to the screen',
  close: 'Close',
  nothing: 'Nothing here.',
  more: (n: number) => `and ${n} more`,
  loading: 'Loading…',
  failed: 'Could not load the flow. It will try again.',
}
